module.exports = "<p>\r\n  home works!!\r\n</p>\r\n\r\n<ul>\r\n\t<li *ngFor=\"let magazine of allMagazines | async\">{{magazine.title}}</li>\r\n</ul>\r\n"